import type { BasicTag } from '@arhs-fleetback/types/entities/tags';
import { TagAction } from '@arhs-fleetback/types/entities/tags';

/**
 * A tag blocks outgoing communication when its actions include
 * `DISABLE_OUTGOING_COMMUNICATION`. Single source of truth for that rule.
 */
export const isCommunicationBlockingTag = (tag: BasicTag): boolean =>
  tag.actions?.includes(TagAction.DISABLE_OUTGOING_COMMUNICATION) ?? false;

export const getCommunicationBlockingTags = (tags: BasicTag[] = []): BasicTag[] =>
  tags.filter(isCommunicationBlockingTag);
